'use client';

export default function PrivacyPolicy() {
    return (
        <div className="font-notojp w-full max-w-full xl:max-w-[90%] mx-auto p-6">
            <h2 className="font-corp text-2xl xl:text-[40px] font-bold text-start mb-6 xl:mb-20">
                プライバシーポリシー
            </h2>
            <section className="mb-6">
                <h3 className="font-corp text-base xl:text-xl font-semibold mb-2">第1条（適用範囲）</h3>
                <p className="text-sm xl:text-base">
                    本プライバシーポリシー（以下「本ポリシー」といいます。）は、当社がお問い合わせフォームを通じて取得する個人情報の取得、利用および管理に適用されます。
                </p>
            </section>
            <section className="mb-6">
                <h3 className="font-corp text-base xl:text-xl font-semibold mb-2">第2条（取得する情報）</h3>
                <p className="text-sm xl:text-base pb-2">当社は、問い合わせ時に以下の個人情報を取得いたします。</p>
                <ul className="list-disc ml-6">
                    <li className="text-sm xl:text-base">メールアドレス</li>
                    <li className="text-sm xl:text-base">担当者氏名</li>
                    <li className="text-sm xl:text-base">住所</li>
                    <li className="text-sm xl:text-base">法人名・法人格</li>
                    <li className="text-sm xl:text-base">部署</li>
                    <li className="text-sm xl:text-base">問い合わせ内容</li>
                    <li className="text-sm xl:text-base">携帯電話番号</li>
                    <li className="text-sm xl:text-base">納品番号</li>
                </ul>
            </section>

            <section className="mb-6">
                <h3 className="font-corp text-base xl:text-xl font-semibold mb-2">第3条（利用目的）</h3>
                <p className="text-sm xl:text-base pb-2">
                    当社が取得した個人情報は、以下の目的のために利用いたします。
                </p>
                <ul className="list-disc ml-6">
                    <li className="text-sm xl:text-base">製品・サービスに関するお問い合わせ対応</li>
                    <li className="text-sm xl:text-base">スクーミー導入前・導入後のご相談対応</li>
                    <li className="text-sm xl:text-base">導入後のサポート</li>
                    <li className="text-sm xl:text-base">製品の使い方に関するご案内</li>
                    <li className="text-sm xl:text-base">サービスに関する情報提供</li>
                    <li className="text-sm xl:text-base">技術的な相談への対応</li>
                    <li className="text-sm xl:text-base">お見積りのご依頼対応</li>
                    <li className="text-sm xl:text-base">代理店契約に関するご相談対応</li>
                    <li className="text-sm xl:text-base">メディアの取材・掲載に関するお問い合わせ対応</li>
                    <li className="text-sm xl:text-base">営業活動（当社のサービスや製品に関するご案内）</li>
                </ul>
            </section>

            <section className="mb-6">
                <h3 className="font-corp text-base xl:text-xl font-semibold mb-2">第4条（個人情報の保管期間）</h3>
                <p className="text-sm xl:text-base">
                    取得した個人情報は、問い合わせ対応のため一定期間保管し、不要になった際には適切な方法で削除いたします。
                </p>
            </section>

            <section className="mb-6">
                <h3 className="font-corp text-base xl:text-xl font-semibold mb-2">第5条（個人情報の第三者提供）</h3>
                <p className="text-sm xl:text-base pb-2">
                    当社は、取得した個人情報を、以下の場合を除き、あらかじめご本人の同意を得ることなく第三者に提供することはありません。
                </p>
                <ul className="list-disc ml-6">
                    <li className="text-sm xl:text-base">法令に基づく場合</li>
                    <li className="text-sm xl:text-base">人の生命、身体または財産の保護のために必要がある場合</li>
                    <li className="text-sm xl:text-base">国の機関・地方公共団体が法令に基づく事務を遂行する場合</li>
                    <li className="text-sm xl:text-base">代理店契約に関するご相談で代理店に情報を共有する場合</li>
                </ul>
            </section>

            <section className="mb-6">
                <h3 className="font-corp text-base xl:text-xl font-semibold mb-2">第6条（個人情報の管理方法）</h3>
                <p className="text-sm xl:text-base">
                    当社は、取得した個人情報の漏えい、滅失または毀損を防止するため、適切な安全管理措置を講じます。ただし、本ポリシーに基づき取得した情報は、基本的に自由にアクセス可能な環境下に保管されるため、ご理解の上でお問い合わせください。
                </p>
            </section>

            <section className="mb-6">
                <h3 className="font-corp text-base xl:text-xl font-semibold mb-2">
                    第7条（個人情報の開示・訂正・削除）
                </h3>
                <p className="text-sm xl:text-base">
                    ご本人からの要請があった場合、当社は速やかに問い合わせ情報の開示、訂正、または削除に対応いたします。
                </p>
            </section>

            <section className="mb-6">
                <h3 className="font-corp text-base xl:text-xl font-semibold mb-2">第8条（本ポリシーの変更）</h3>
                <p className="text-sm xl:text-base">
                    当社は、必要に応じて本ポリシーを変更することがあります。本ポリシーの変更を行った場合には、本ウェブサイト上に掲載いたします。
                </p>
            </section>

            <section className="mb-6">
                <h3 className="font-corp text-base xl:text-xl font-semibold mb-2">第9条（お問い合わせ窓口）</h3>
                <div className="bg-gray-100 p-4 rounded">
                    <p className="font-bold text-sm xl:text-base">個人情報取扱事業者：</p>
                    <p className="text-sm xl:text-base pb-2">株式会社スクーミー</p>
                    <p className="font-bold text-sm xl:text-base">代表者名：</p>
                    <p className="text-sm xl:text-base pb-2">塩島諒輔</p>
                    <p className="font-bold text-sm xl:text-base">住所：</p>
                    <p className="text-sm xl:text-base pb-2">山梨県甲府市大手1−2−21 イノベーションベースSoie101</p>
                    <p className="font-bold text-sm xl:text-base">メール：</p>
                    <p className="text-sm xl:text-base">go@schoomy.com</p>
                </div>
            </section>
            <p className="text-end text-gray-500 pr-4 pb-8">以上</p>
        </div>
    );
}
